<template>
    <el-form :model="jobNoForm" :rules="jobNoRules" class="jobNo-form" ref="jobNoElForm" size="medium">
        <el-form-item class="form-item" prop="jobNo">
            <i class="nucfont inuc-person"></i>
            <el-input type="text" v-model="jobNoForm.jobNo"
                      :placeholder="$t('app.jobNo')"></el-input>
        </el-form-item>
        <el-form-item class="form-item" prop="password">
            <i class="nucfont inuc-password"></i>
            <el-input type="password" v-model="jobNoForm.password"
                      :placeholder="$t('app.pwd')"></el-input>
        </el-form-item>
        <el-form-item class="form-item" prop="enterpriseCode">
            <i class="nucfont inuc-qiye"></i>
            <el-input type="text" v-model="jobNoForm.enterpriseCode"
                      :placeholder="$t('app.enterpriseCode')"></el-input>
        </el-form-item>
        <el-form-item class="form-item" prop="type">
            <el-radio-group v-model="jobNoForm.type" size="medium">
                <el-radio-button label="Admin">{{$t('app.admin')}}</el-radio-button>
                <el-radio-button label="Trainer">{{$t('app.trainer')}}</el-radio-button>
                <el-radio-button label="Student">{{$t('app.student')}}</el-radio-button>
            </el-radio-group>
        </el-form-item>
    </el-form>
</template>

<script>
    const config = require("@/config")

    export default {
        data() {
            return {
                jobNoForm: {
                    jobNo: "",
                    password: "",
                    enterpriseCode: "",
                    type: ""
                },
                jobNoRules: {
                    jobNo: [
                        {required: true, message: this.$t('app.jobNo'), trigger: "blur"}
                    ],
                    password: [
                        {required: true, message: this.$t('app.pwd'), trigger: "blur"}
                    ],
                    enterpriseCode: [
                        {required: true, message: this.$t('app.enterpriseCode'), trigger: "blur"}
                    ],
                    type: [
                        {required: true, message: this.$t('app.roleType'), trigger: "change"}
                    ],
                },
            }
        },
        methods: {
            login() {
                const data = {
                    ...this.jobNoForm,
                    version: config.version
                }

                return new Promise((resolve, reject) => {
                    this.$refs['jobNoElForm'].validate(valid => {
                        if (!valid) {
                            reject('表单验证未通过')
                            return
                        }

                        resolve(this.$api.jobNoLogin(data))
                    })
                })
            }
        },
    }
</script>
